/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type freeTextFieldComponent_viewer = {
    readonly id: string;
    readonly " $refType": "freeTextFieldComponent_viewer";
};
export type freeTextFieldComponent_viewer$data = freeTextFieldComponent_viewer;
export type freeTextFieldComponent_viewer$key = {
    readonly " $data"?: freeTextFieldComponent_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"freeTextFieldComponent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "freeTextFieldComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '86070892a6dab04d87639c3e6fa3ea10';
export default node;
